import { render } from "./PagesInput.vue?vue&type=template&id=0cc76041&scoped=true"
import script from "./PagesInput.vue?vue&type=script&lang=js"
export * from "./PagesInput.vue?vue&type=script&lang=js"

import "./PagesInput.vue?vue&type=style&index=0&id=0cc76041&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc76041"]])

export default __exports__